var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreedial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 354,
    height: 120,
    viewBox: "0 0 354 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2,.cls-4{fill:#ffc300}.cls-2{font-size:32px;font-family:HiraKakuProN-W6,Hiragino Kaku Gothic ProN}.cls-3{fill:#fff;font-size:11px;font-family:HiraKakuProN-W3,Hiragino Kaku Gothic ProN}.cls-5{filter:url(#Rectangle_Copy_5)}\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_Copy_5",
    width: 354,
    height: 120,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#dce0e0",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_228",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 228",
    transform: "translate(-10.5 -3168.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5",
    transform: "translate(10.5 3168.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_5-2",
    width: 345,
    height: 111,
    className: "cls-1",
    "data-name": "Rectangle Copy 5",
    rx: 5,
    transform: "translate(4.5 3.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_225",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 225",
    transform: "translate(5.994 -72)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0120-559-442",
    className: "cls-2",
    "data-name": "0120-559-442",
    transform: "translate(81.638 3299.512)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0120-559-442")), /*#__PURE__*/React.createElement("text", {
    id: "\\u53D7\\u4ED8\\u6642\\u9593_",
    className: "cls-3",
    "data-name": "\\u53D7\\u4ED8\\u6642\\u9593\\uFF1A",
    transform: "translate(32 3330.635)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u53D7\u4ED8\u6642\u9593\uFF1A")), /*#__PURE__*/React.createElement("text", {
    id: "\\u5E73\\u65E510:00_19:00",
    className: "cls-3",
    "data-name": "\\u5E73\\u65E510:00\\u301C19:00",
    transform: "translate(86.728 3330.635)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5E73\u65E510:00\u301C19:00")), /*#__PURE__*/React.createElement("text", {
    id: "_\\u571F\\u65E5_\\u795D\\u65E5_\\u5E74\\u672B\\u5E74\\u59CB\\u4F11\\u307F_",
    className: "cls-3",
    "data-name": "\\uFF08\\u571F\\u65E5\\u30FB\\u795D\\u65E5\\u30FB\\u5E74\\u672B\\u5E74\\u59CB\\u4F11\\u307F\\uFF09",
    transform: "translate(179.985 3330.635)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uFF08\u571F\u65E5\u30FB\u795D\u65E5\u30FB\u5E74\u672B\u5E74\u59CB\u4F11\u307F\uFF09"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u767D\\u629C\\u304D\\u306E\\u96FB\\u8A71\\u30A2\\u30A4\\u30B3\\u30F3_3",
    "data-name": "\\u767D\\u629C\\u304D\\u306E\\u96FB\\u8A71\\u30A2\\u30A4\\u30B3\\u30F3 3",
    transform: "rotate(-45 3892.21 1579.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_6433",
    d: "M22.536 0a22.536 22.536 0 1 0 22.536 22.536A22.537 22.537 0 0 0 22.536 0zm2.375 16.136h-1.634V8.619h1.634a1.3 1.3 0 0 1 1.3 1.3v4.921a1.3 1.3 0 0 1-1.3 1.296zm1.3 14.1v4.927a1.3 1.3 0 0 1-1.3 1.3h-1.634v-7.527h1.634a1.3 1.3 0 0 1 1.296 1.296zm-3.82-14.066a1.3 1.3 0 0 0-1 1.1 29.2 29.2 0 0 0-.364 5.268 29.179 29.179 0 0 0 .363 5.262 1.3 1.3 0 0 0 1 1.1v7.553h-.45c-3.149 0-5.892-6.908-5.892-13.919S18.79 8.619 21.94 8.619h.451z",
    className: "cls-4",
    "data-name": "\\u30D1\\u30B9 6433"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreedial);
export default __webpack_public_path__ + "static/media/freedial.62ed42310bb360a1706c5d43dc6a039c.svg";
export { ForwardRef as ReactComponent };